// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Adapter authentication method.
 */
export enum AdapterAuth {
  NONE = 0,
  APIKEY = 1,
  PASSWORD = 2,
  JWT = 3,
  OAUTH = 4,
}
